import { TypographyProps } from '@mui/material';
import { PropsWithChildren } from 'react';

import { ThreadStatus } from '../../../../../../Cockpit.types';
import { AgentSummaryListItemProps } from '../ThreadSummaryListItem/ThreadSummaryListItem';
import { ClampedMultiline } from '~/components/ClampedMultiline/ClampedMultiline';

const statusStylingMap: Record<ThreadStatus, TypographyProps> = {
  [ThreadStatus.UNREAD]: {
    variant: 'subtitle2',
    color: 'textPrimary',
  },
  [ThreadStatus.READ]: {
    variant: 'body2',
    color: 'textPrimary',
  },
  [ThreadStatus.COMPLETED]: {
    variant: 'body2',
    color: 'textDisabled',
  },
};

export const ThreadSummaryText = ({
  status,
  children,
}: PropsWithChildren<Pick<AgentSummaryListItemProps, 'status'>>) => {
  const summaryProps = {
    lines: 2,
    ...statusStylingMap[status],
  };
  return <ClampedMultiline {...summaryProps}>{children}</ClampedMultiline>;
};
